import React from 'react';
import '../styles/GridTitle.css'

export default function GridTitle (props) {

  return (
    <div className='title'>
        <h1>{props.title}</h1>
        <h2>{props.subtitle}</h2>
        <p>{props.text}</p>
    </div>
  );
};

